import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as imageHelper from '../../../helpers/imageHelper';
import * as animationHelper from "../../../helpers/animationHelper";

class LibraryImage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            image: {
                src: ""
            },
            screenStatus: "",
            checkComplete: false,
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            allowScroll: appHelper.allowScroll(this.props.callbacks.getBiteId(), this.props.callbacks.getScreenId(), this.props.screenObject.asset_id),
            isTracking: !appHelper.isDefined(this.props.isTracking) || (appHelper.isDefined(this.props.isTracking) && this.props.isTracking),
            imageClass: "",
            imageStylesSet: false,
            updateImageStyles: false,
            refValue: `image_${this.props.screenObject.asset_id}`,
            asset: {},
            doShow: false,
            continue_label: appHelper.getLocaleString("continue_label"),
            credit_label: appHelper.getLocaleString("credit_label")
        };
        this.getAssets = this.getAssets.bind(this);
        this.show = this.show.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.setClass = this.setClass.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.enableProgression = this.enableProgression.bind(this);
        this.disableProgression = this.disableProgression.bind(this);
        this.onProgressionBtnClicked = this.onProgressionBtnClicked.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getScreenStatus = this.getScreenStatus.bind(this);
        this.getObjectStatus = this.getObjectStatus.bind(this);
        this.onCloseAssetDialog = this.onCloseAssetDialog.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        this.getAssets();
        this.getScreenStatus();

        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }


    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                continue_label: appHelper.getLocaleString("continue_label"),
                credit_label: appHelper.getLocaleString("credit_label")
            });
        }
    }

    componentDidUpdate() {

        if (this.state.checkComplete) {
            this.onComplete();
        }
        if (!this.state.imageStylesSet) {
            this.getImageStyles();
        }
        if (this.state.doShow) {
            this.show();
        }
    }

    getScreenStatus() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        this.setState({
            screenStatus: screenStatus,
            status: screenStatus === objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_COMPLETE : this.state.status
        });
    }

    getObjectStatus() {
        this.scrollToTop();
        if (this.state.screenStatus === objectConstants.STATUS_COMPLETE) {
            this.onComplete();
        } else {
            let objectUserData = {};
            if (this.state.status !== objectConstants.STATUS_COMPLETE) {
                let subScreenParent = this.props.callbacks.getSubScreenParent();
                let screen_id = this.props.callbacks.getScreenId();
                if (appHelper.isDefined(subScreenParent)) {
                    objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
                } else if (this.state.isResourceObject) {
                    objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
                } else {
                    objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
                }
            }
            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                this.setState({status: objectConstants.STATUS_COMPLETE, checkComplete: true});
            } else {
                this.setState({checkComplete: true});
            }
        }
    }

    getAssets() {
        let image = appHelper.getLibraryImageAsset(this.state.screenObject);
        this.setState({
            image: image,
            asset: Object.assign({}, this.state.screenObject, {
                image: image
            }),
            updateImageStyles: true,
        });

    }

    show() {
        this.setState({doShow: false});
        let objectRef = this.objectRef.current;
        if(appHelper.isObjectEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: this.getObjectStatus
            };
            animationHelper.showHeight(params);
        }
    }

    scrollToTop() {
        let screenStatus = this.props.callbacks.getScreenStatus();
        if (this.state.allowScroll && this.state.status !== objectConstants.STATUS_COMPLETE && screenStatus !== objectConstants.STATUS_COMPLETE) {
            let image = this.objectRef.current;
            let scrollTo = this.props.callbacks.scrollTo;
            setTimeout(function () {
                if (appHelper.isDefined(scrollTo) && appHelper.isEleDefined(image)) {
                    scrollTo(image.offsetTop, true);
                }
            }, objectConstants.SCROLL_TO);
        }
    }


    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        } else {
            return "not-started";
        }
    }

    onComplete() {
        this.setState({checkComplete: false});
        if (this.state.isTracking) {
            let hasNextObject = this.props.callbacks.hasNextObject(this.props.index);
            if (appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE && (this.state.status !== objectConstants.STATUS_COMPLETE || !hasNextObject)) {
                if (!hasNextObject && !this.state.isResourceObject) {
                    this.handleProgression();
                    this.enableProgression();
                } else if (!hasNextObject && this.state.isResourceObject) {
                    this.handleProgression();
                } else {
                    this.enableProgression();
                }

            } else {
                this.handleProgression();
            }
        }
        this.scrollToTop();
    }

    enableProgression() {
        if (!this.props.callbacks.isReviewMode()) {
            this.setState({showProgressionButton: true});
        }
    }

    disableProgression() {
        this.setState({showProgressionButton: false});
    }

    handleProgression() {
        let progressionRule = appHelper.isDefined(this.state.screenObject.progression) ? this.state.screenObject.progression : objectConstants.OBJECT_PROGRESSION_CONTINUE;
        let progressionType = appHelper.isDefined(this.state.screenObject.progression_type) ? this.state.screenObject.progression_type : undefined;
        let progressionGoToId = appHelper.isDefined(this.state.screenObject.progression_goto_id) ? this.state.screenObject.progression_goto_id : undefined;
        let completionData = {
            progression: progressionRule,
            progressionType: progressionType,
            progressionGoToId: progressionGoToId,
            asset_id: this.state.screenObject.asset_id,
            status: objectConstants.STATUS_COMPLETE,
            showProgressionButton: false,
            asset_type_code: this.state.screenObject.asset_type_code,
            navigateToNextScreen: !this.state.isResourceObject && appHelper.isDefined(this.state.screenObject.progression) && this.state.screenObject.progression === objectConstants.OBJECT_PROGRESSION_CONTINUE,
            index: this.props.index
        };

        this.props.callbacks.onObjectComplete(completionData);
        //t

    }

    onProgressionBtnClicked() {
        this.setState({showProgressionButton: false});
        if (this.props.callbacks.hasNextObject(this.props.index) || this.state.isResourceObject) {
            this.handleProgression();
        } else {
            this.props.callbacks.navigateToNextScreen();
        }
    }

    onCloseAssetDialog(viewed) {
        /*let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
        if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
            this.updateResourceObjectResult();
        }*/
    }

    getImageStyles() {
        let refValue = this.objectRef.current;
        if (appHelper.isEleDefined(refValue) && appHelper.isDefined(this.state.asset.asset_id) && this.state.image.src.length > 0) {
            let excludePadding = (appHelper.isDefined(this.props.callbacks.hasSidePanel) && this.props.callbacks.hasSidePanel()) || (this.state.screenObject.image_size === objectConstants.IMAGE_SIZE_SPECIFIC && this.state.screenObject.asset_image_width === objectConstants.TOP_ASSET_IMAGE_WIDTH_100) || this.state.screenObject.image_size === objectConstants.IMAGE_SIZE_MAX;
            let assetStyles = imageHelper.checkAssetImageWidth(this.state.asset, this.state.image, refValue.offsetWidth, excludePadding).styles;

            this.setState({
                updateImageStyles: false,
                imageStylesSet: true,
                imageStyles: Object.assign({}, assetStyles),
                imageClass: imageHelper.getAssetImageClass(this.state.asset),
                doShow: true,
            });

        }
    }


    render() {
        return (
            <div className="a-c" ref={this.objectRef}>
                <div className="object-container text-center">
                    {this.state.imageStylesSet
                        ?
                        <div className={`library-image-object`} >
                            <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                 style={this.state.imageStyles}>
                                <img src={this.getImagePath(this.state.image.src)} alt={this.state.screenObject.name}/>
                            </div>
                            {appHelper.isDefined(this.state.image.credit) && this.state.image.credit.length > 0
                            &&
                            <div className="image-credit center"
                                 style={this.state.imageStyles}>{this.state.credit_label}: {this.state.image.credit}</div>
                            }
                        </div>
                        : null
                    }

                    {this.state.showProgressionButton
                        ? <Button label={this.state.continue_label}
                                  id={`${this.state.screenObject}_button`}
                                  onClick={this.onProgressionBtnClicked}/>
                        : null
                    }
                </div>
            </div>

        );
    }
}

LibraryImage.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    isTracking: PropTypes.bool,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

LibraryImage.contextTypes = {
    router: PropTypes.object
};

/*
* <ParagraphText screenObject={this.state.screenObject}
                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
                                   id={`${this.state.screenObject}_description`}
                                   class_name="document-description"
                                   objectKey={`description`}/>*/

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LibraryImage);



/** WEBPACK FOOTER **
 ** ./src/components/objects/image/LibraryImage.js
 **/